/**
 *  Module for HorizontalPagination
 */

const HorizontalPagination = function (app) {

  /**
   *  Private Properties/Methods
   */
  const $ = require('jquery'),
    containerEl = app.$container.get(0),
    _ = require('lodash');
  /* =============================================
  =            Horizontal Pagination             =
  ============================================= */
  const LEFT_ARROW_ID = 'fc-left-arrow',
    RIGHT_ARROW_ID = 'fc-right-arrow',
    DOTS_GROUP_ID = 'fc-swatch-group-dots',
    DOTS_GEN_CLASS = 'fc-swatch-group-dots',
    ARROW_MARGIN_L = 19,
    ARROW_MARGIN_R = 6;

  function getDotsClassName(id) {
    return DOTS_GROUP_ID + '_' + id;
  }
  function getLeftArrowClassName(id) {
    return LEFT_ARROW_ID + '_' + id;
  }
  function getRightArrowClassName(id) {
    return RIGHT_ARROW_ID + '_' + id;
  }
  function getDotId(i, parentId) {
    return 'fc-swatch-dots-' + i + '_' + parentId;
  }
  function removeElementsByClassName(className) {
    const elements = containerEl.getElementsByClassName(className);
    return Array.prototype.slice.call(elements).map(function (element) {
      $(element).remove();
    });
  }
  function removeHorizontalStyles($swatchesContainer, parentSwatchesContainer, parentSwatchesContainerId) {
    /**
      In case we loaded the scroll, at the current panel, we need to:
      - Remove Arrows
      - Remove Dots/pages
      - Remove margin-left and margin-right
      - remove width and height on parent
     */
    const leftArrowClassName = getLeftArrowClassName(parentSwatchesContainerId);
    removeElementsByClassName(leftArrowClassName);

    const rightArrowClassName = getRightArrowClassName(parentSwatchesContainerId);
    removeElementsByClassName(rightArrowClassName);

    const dotsClassName = getDotsClassName(parentSwatchesContainerId);
    removeElementsByClassName(dotsClassName);

    $swatchesContainer.attr('style', '');
    if (parentSwatchesContainer && parentSwatchesContainer.style) {
      parentSwatchesContainer.style.cssText = 'margin-left: 0 !important; margin-right: 0 !important; width: auto !important; margin-bottom: 15px;';
    }
    return;
  }


  function scrollIntoActiveSwatch(parentSwatchesContainer) {
    const selectedSwatch = parentSwatchesContainer.querySelector('[aria-checked=true]');
    const containerWidth = parentSwatchesContainer.offsetWidth;
    const selectedSwatchPosition = selectedSwatch.offsetLeft;
    const containerScrollPosition = parentSwatchesContainer.scrollLeft;
    if (!(selectedSwatchPosition < containerScrollPosition + containerWidth && selectedSwatchPosition > containerScrollPosition)) {
      const page = Math.floor(selectedSwatchPosition / containerWidth);
      parentSwatchesContainer.scrollLeft = page * containerWidth;
    }
  }


  function addArrowsAndDots(options) {
    const $parentSwatchesContainer = $(options.parentSwatchesContainer);
    const leftArrowClassName = getLeftArrowClassName(options.parentSwatchesContainerId);
    const rightArrowClassName = getRightArrowClassName(options.parentSwatchesContainerId);
    const dotsClassName = getDotsClassName(options.parentSwatchesContainerId);

    /* ----------  Create Arrows  ---------- */
    // var $swatchesContainer = $('.fc-accordion-panel.fc-is-open').find('.fc-attribute-selector-swatch');
    function scrollRight() {
      $parentSwatchesContainer.animate({ scrollLeft: '+=' + $parentSwatchesContainer.width() }, 400);
    }
    function scrollLeft() {
      $parentSwatchesContainer.animate({ scrollLeft: '-=' + $parentSwatchesContainer.width() }, 400);
    }
    $('.' + leftArrowClassName).remove();
    $('.' + rightArrowClassName).remove();
    options.$swatchesContainer.before('<div class="' + leftArrowClassName + '" id="' + LEFT_ARROW_ID + '"><<</div>');
    options.$swatchesContainer.before('<div class="' + rightArrowClassName + '" id="' + RIGHT_ARROW_ID + '">>></div>');
    $('.' + leftArrowClassName).click(scrollLeft);
    $('.' + rightArrowClassName).click(scrollRight);
    /* ----------  create page navigation.  ---------- */
    // $('#' + DOTS_GROUP_ID).remove();
    removeElementsByClassName(dotsClassName);
    $parentSwatchesContainer.after('<ul class="' + dotsClassName + ' ' + DOTS_GEN_CLASS + '"></ul>');
    // var $scrollGroup = $('.fc-accordion-panel.fc-is-open').find('.fc-swatch-group');
    const pages = Math.ceil(options.$swatchesContainer.width() / $parentSwatchesContainer.width());
    for (let i = 0; i < pages; i++) {
      const id = getDotId(i, options.parentSwatchesContainerId);
      $('.' + dotsClassName).append('<li id="' + id + '">' + (i + 1) + '</li>');
      const dot = document.getElementById(id);
      dot.addEventListener('click', (function (i) {
        return function () {
          $parentSwatchesContainer.animate({ scrollLeft: i * $parentSwatchesContainer.width() }, 400);
        };
      })(i));
    }
    /* ----------  Add margin to element, so arrows have space.  ---------- */
    options.parentSwatchesContainer.style.cssText = 'margin-left: ' + ARROW_MARGIN_L + 'px; margin-right: ' +
      ARROW_MARGIN_R + 'px; width: ' + options.parentContainerWidth + 'px;';
    function defineActivePage() {
      const activeClassname = 'fc-swatch-dots-active-page';
      const position = options.parentSwatchesContainer.scrollLeft;
      // we remove from parent width a 10% value.
      const parentWidth = $parentSwatchesContainer.width() - ($parentSwatchesContainer.width() * 0.1);
      const page = Math.floor(position / parentWidth);
      const id = getDotId(page, options.parentSwatchesContainerId);
      $('.' + dotsClassName).find('.' + activeClassname).toggleClass(activeClassname);
      $('#' + id).addClass(activeClassname);
    }
    defineActivePage();
    $parentSwatchesContainer.scroll(defineActivePage);
  }


  function generateHorizontalSlider(panelOpened, parentSwatchesContainer) {
    const parentSwatchesContainerId = parentSwatchesContainer.dataset.id;
    const swatchesContainer = parentSwatchesContainer.getElementsByClassName('fc-swatch-group')[0];
    const $swatchesContainer = $(swatchesContainer);
    let $children = $(swatchesContainer).find('.fc-swatch-ca').not(':has(.fc-av-unselectable)');

    // Remove hidden swatches from count
    $children = $(_.compact(_.map($children, child => {
      return (child.offsetParent !== null) ? child : null;
    })));

    const childrenCount = $children.length;

    let paddingRight = 0;
    // prevent previous injected styles to modify the desired result.
    removeHorizontalStyles($swatchesContainer, parentSwatchesContainerId, parentSwatchesContainer);
    const parentContainerWidth = $(panelOpened).width() - (ARROW_MARGIN_L + ARROW_MARGIN_R);
    let swatchHeight = 0,
      swatchWidth = 0;
    $children.map(function (index, child) {
      swatchHeight = child.offsetHeight > swatchHeight ? child.offsetHeight : swatchHeight;
      swatchWidth = child.offsetWidth > swatchWidth ? child.offsetWidth : swatchWidth;
    });
    let marginWidth = $children.first().css(['margin-right', 'margin-left']);
    marginWidth = _.reduce(marginWidth, function (accum, value) {
      accum += +value.match(/\d{1,3}/)[0];
      return accum;
    }, 0);
    let marginHeight = $children.first().css(['margin-top', 'margin-bottom']);
    marginHeight = _.reduce(marginHeight, function (accum, value) {
      accum += +value.match(/\d{1,3}/)[0];
      return accum;
    }, 0);
    const swatchesPerRow = Math.floor(parentSwatchesContainer.offsetWidth / (swatchWidth + marginWidth));
    const swatchesPerPage = swatchesPerRow * 2;
    if (childrenCount <= swatchesPerPage) {
      return removeHorizontalStyles($swatchesContainer, parentSwatchesContainer, parentSwatchesContainerId);
    }
    const swatchBreak = Math.ceil((childrenCount / swatchesPerRow) / 2) * swatchesPerRow,
      numRows = Math.ceil($children.length / swatchBreak);
    const width = numRows === 1 ? ((swatchWidth + marginWidth) * childrenCount) : ((swatchWidth + marginWidth) * swatchBreak),
      height = (swatchHeight + marginHeight) * numRows;
    const lastPageSwatches = childrenCount % swatchesPerPage;
    const addPadding = lastPageSwatches / swatchesPerRow < 1;
    if (addPadding && lastPageSwatches) {
      paddingRight = (swatchesPerRow - (childrenCount % swatchesPerRow)) * (swatchWidth + marginWidth);
    };
    $swatchesContainer.css({
      height: height + 'px',
      width: width + 'px',
      paddingRight: paddingRight + 'px'
    });
    addArrowsAndDots({
      parentSwatchesContainerId,
      parentSwatchesContainer,
      parentContainerWidth,
      $swatchesContainer
    });
    scrollIntoActiveSwatch(parentSwatchesContainer);
  }

  function disableCarousel() {
    // Currently we are going to hardcode a list of product ID's so RAL and run
    // a test in production on T-Shirts. Unfortunately there are no facets we
    // can use just for T-Shirts so for now we will add the Product ID's.
    // When/If this needs to be changed we will either enable this for all
    // products or we will update the code to leverage a product facet.
    const productIds = [
      // CYO
      22582, // NA/EU Men's T-shirt
      22584, // NA/EU Women's T-Shirt
      23208, // NA/EU Boys' T-Shirt
      23262, // NA/EU Girls' T-Shirt
      23210, // NA/EU Baby Boy T-Shirt

      // DTG
      23316, // NA/EU  Men's T-Shirt
      23318, // NA/EU  Women's T-Shirt
      23319, // NA/EU  Boys' T-Shirt
      23320  // NA/EU  Girls' T-Shirt
    ];
    // Find the hardcoded ID based on the current product ID.
    const matchedId = _.indexOf(productIds, app.product.id) >= 0;

    return matchedId || app.mergedParams.disableCarousel;
  }


  function setSwatchRows() {
    if (disableCarousel()) { return false; }
    const panelOpen = containerEl.getElementsByClassName('fc-accordion-panel fc-is-open');
    const parentsSwatchesContainer = panelOpen[0].getElementsByClassName('fc-attribute-selector-swatch');
    Array.prototype.slice.call(parentsSwatchesContainer).map(function (parentSwatchesContainer) {
      generateHorizontalSlider(panelOpen, parentSwatchesContainer);
    });
  }


  function horizontalPages() {
    if (disableCarousel()) { return false; }
    setTimeout(function () {
      setSwatchRows();
    }, 1);
  }
  /* =====  End of Horizontal Pagination  ====== */

  /**
   *  Expose Public Properties/Methods
   */
  return {
    horizontalPages,
    setSwatchRows
  };
};

module.exports = HorizontalPagination;
